import { render } from "./NoPay.vue?vue&type=template&id=edc978fc&scoped=true"
import script from "./NoPay.vue?vue&type=script&lang=js"
export * from "./NoPay.vue?vue&type=script&lang=js"

import "./NoPay.vue?vue&type=style&index=0&id=edc978fc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc978fc"]])

export default __exports__